import React, { useReducer } from "react"; // eslint-disable-line no-unused-vars
import * as consts from "../consts";
import { State } from "./state";

const initialState = {
  alerts: [],
  busy: false,
  profile: null,
  cart: localStorage.getItem(consts.STORAGE_CART)
    ? JSON.parse(localStorage.getItem(consts.STORAGE_CART))
    : [],
};

function reducer(state, action) {
  switch (action.type) {
    case consts.ACTION_ADD_ALERT:
      return { ...state, alerts: [...state.alerts, action.payload] };
    case consts.ACTION_DISMISS_ALERT: {
      let updatedAlerts = state.alerts.slice();
      updatedAlerts.shift();
      return {
        ...state,
        alerts: updatedAlerts,
      };
    }
    case consts.ACTION_SET_BUSY:
      return { ...state, busy: action.payload };
    case consts.ACTION_INITIALIZE_PROFILE:
      return {
        ...state,
        profile: action.payload,
      };
    case consts.ACTION_SET_CART: {
      localStorage.setItem(consts.STORAGE_CART, JSON.stringify(action.payload));
      let event = document.createEvent("StorageEvent");
      event.initStorageEvent(
        "storage",
        false,
        false,
        consts.STORAGE_CART,
        JSON.stringify(state.cart),
        JSON.stringify(action.payload),
        window.location.href,
        window.localStorage
      );
      window.dispatchEvent(event);
      return {
        ...state,
        cart: action.payload,
      };
    }
    default:
      return state;
  }
}

export function Provider(props) {
  const [state, dispatch] = useReducer(reducer, initialState);
  const value = { state, dispatch };
  return <State.Provider value={value}>{props.children}</State.Provider>;
}
